// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WDNA","colMin":"styles_colMin__sCn99"};